import { z } from 'zod';

export const DocScreenshotUploadOk = z.object({
  id: z.string().uuid(),
  minio_key: z.string(),
  signed_url: z.string().min(1), // absolute URL (S3) либо относительный путь (local-fs fallback)
  filename: z.string(),
});
export type DocScreenshotUploadOk = z.infer<typeof DocScreenshotUploadOk>;

export const DocSearchHit = z.object({
  slug: z.string(),
  role: z.string(),
  title: z.string(),
  snippet_html: z.string(),
  score: z.number(),
});
export type DocSearchHit = z.infer<typeof DocSearchHit>;

export const DocSearchResponse = z.object({
  query: z.string(),
  results: z.array(DocSearchHit),
  total: z.number().int(),
});
export type DocSearchResponse = z.infer<typeof DocSearchResponse>;

export const DocReadStateRequest = z
  .object({
    version: z.number().int().min(1),
  })
  // zod-strict-ok: input request-body
  .strict();
export type DocReadStateRequest = z.infer<typeof DocReadStateRequest>;
